<label
  class="flex gap-1 justify-center items-center text-sm"
  [ngClass]="[
    selected()
      ? {
          default:
            'bg-surface dark:bg-surface-darkmode text-on-surface dark:text-on-surface-darkmode',
          primary:
            'bg-primary dark:bg-primary-darkmode text-on-primary dark:text-on-primary-darkmode',
          destructive: 'bg-error dark:bg-error-darkmode text-on-error dark:text-on-error-darkmode',
        }[mode()]
      : 'text-on-surface-variant dark:text-on-surface-variant-darkmode',
    isDisabled() ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
  ]"
>
  <input
    type="radio"
    [value]="value()"
    [checked]="selected()"
    [name]="name()"
    [disabled]="isDisabled()"
    class="flex-none sr-only"
    [attr.aria-labelledby]="name() + '-' + value()"
  />
  <div class="flex-1 flex gap-1.5 items-center justify-center" [attr.id]="name() + '-' + value()">
    <ng-content />
  </div>
</label>
